import { combineReducers } from "redux";
import userReducer from './userReducer';
import tokenReducer from "./tokenReducer";
import loanApplicationReducer from "./loanApplicationReducer";
import pendingLoanReducer from "./pendingLoanReducer";
import userDetailsReducer from "./userDetailsReducer";
import  postFirstLoanReducer from './loanPostReducer';
import loanHistoryReducer from './loanHistoryReducer';
import userLoanApprovalReducer from './userLoanApprovalReducer';
import sendOTPReducer from './sendOTPReducer';
import vendorDetailsReducer from './vendorDetailsReducer';

const rootReducer = combineReducers({
    user: userReducer,
    token: tokenReducer,
    pendingLoans: pendingLoanReducer,
    loanApplication: loanApplicationReducer,
    userDetails: userDetailsReducer,
    firstLoanApproval: postFirstLoanReducer,
    loanHistory: loanHistoryReducer,
    userLoanApproval: userLoanApprovalReducer,
    sendOTP: sendOTPReducer,
    vendorDetails: vendorDetailsReducer
});

export default rootReducer;